// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingLiveLens_loadingContainer__nXPC3","afterCameraPermissionText":"LoadingLiveLens_afterCameraPermissionText__HRwz7"};